var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"title secondary--text"},[_vm._v(_vm._s(_vm.title))]),_c('v-divider',{staticClass:"mt-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }